import { FC, useEffect, useRef, useState } from 'react';

interface iSidebarFooterProps {
  price: number | null;
  isLoading: boolean;
  onSubmit: () => void;
  error?: string | null;
  label?: string | null;
}

const Loading = () => {
  const [dots, setDots] = useState('');
  const length = useRef(0);

  useEffect(() => {
    const interval = setInterval(() => {
      length.current = Math.max(1, (length.current + 1) % 4);
      setDots(new Array(length.current).fill('.').join(''));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return <>Adding {dots}</>;
};
const SidebarFooter: FC<iSidebarFooterProps> = ({ price, onSubmit, error, isLoading, label }) => {
  return (
    <footer className='sidebar'>
      <div className='body'>
        <label>Price</label>
        <span className='price'>{price ? `£${price.toFixed(2)}` : '-'}</span>
      </div>
      {/* {price >= 100 && <span className='free'>+ Free UK Delivery</span>} */}
      <button disabled={!!error} onClick={onSubmit}>
        {label || (
          <>
            {error && <div className='popup'>Hmm, that's quite a big sign, contact us.</div>}
            {error ?? (isLoading ? <Loading /> : 'Add to cart')}
          </>
        )}
      </button>
    </footer>
  );
};

export default SidebarFooter;
